import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="preview-template"
export default class extends Controller {
  static targets = [
    "instruction",
    "initialPrompt",
    "prompt",
    "fieldsPair",
    "preview",
  ];

  connect() {
    this.initialInstruction = this.instructionTarget.innerText;
    this.initialPrompt = this.promptTarget.innerText;
  }

  addInstruction(event) {
    const space = event.currentTarget.value ? "\n\n" : "";
    this.instructionTarget.innerText = `${this.initialInstruction}${space}${event.currentTarget.value}`;
  }

  addPrompt() {
    const fieldsPair = this.fieldsPairTargets
      .filter((pair) => {
        const fields = Array.from(pair.querySelectorAll("input, textarea"));
        return !fields.every((field) => field.value === "");
      })
      .map((pair) => {
        const fields = Array.from(pair.querySelectorAll("input, textarea"));
        const tagNames = fields.map((field) => field.tagName);
        const formattedValues = tagNames.includes("TEXTAREA")
          ? "\n" + fields.map((field) => field.value).join("\n\n")
          : `${fields.map((field) => field.value).join(" : ")}`;

        return formattedValues;
      });
    const initialSpace = this.initialPromptTarget.value === "" ? "" : "\n\n";
    const space = fieldsPair.length === 0 ? "" : "\n\n";
    this.promptTarget.innerText = `${this.initialPrompt}${initialSpace}${this.initialPromptTarget.value}${space}${fieldsPair.join("\n")}`;
    this.previewTarget.scrollIntoView({
      behavior: "smooth",
      block: "end",
    });
  }
}
